<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Escolaridade:"
    id="selectEscolaridade"
    placeholder="Selecione a escolaridade"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectEscolaridade',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'ANALFABETO', text: 'ANALFABETO' },
        {
          value: 'ENSINO FUNDAMENTAL INCOMPLETO',
          text: 'ENSINO FUNDAMENTAL INCOMPLETO'
        },
        {
          value: 'ENSINO FUNDAMENTAL COMPLETO',
          text: 'ENSINO FUNDAMENTAL COMPLETO'
        },
        { value: 'ENSINO MÉDIO INCOMPLETO', text: 'ENSINO MÉDIO INCOMPLETO' },
        { value: 'ENSINO MÉDIO COMPLETO', text: 'ENSINO MÉDIO COMPLETO' },
        {
          value: 'ENSINO SUPERIOR INCOMPLETO',
          text: 'ENSINO SUPERIOR INCOMPLETO'
        },
        { value: 'ENSINO SUPERIOR COMPLETO', text: 'ENSINO SUPERIOR COMPLETO' },
        { value: 'PÓS-GRADUAÇÃO', text: 'PÓS-GRADUAÇÃO' },
        { value: 'MESTRADO', text: 'MESTRADO' },
        { value: 'DOUTORADO', text: 'DOUTORADO' }
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectEscolaridade.vue